export class RandomHelper {
    public static randomInt32(): number {
        const array = new Int32Array(1);

        window.crypto.getRandomValues(array);

        return array[0];
    }
}